module.exports = __webpack_public_path__ + "img/google-shopping.dc5e0bf9.png";